module.exports = __webpack_public_path__ + "img/shopInfo_medic_2.68be1081.jpg";